import React from "react";
import moment from "moment";
import classnames from "classnames";
import "moment/locale/sv";
import { DateObject } from 'react-multi-date-picker';
import { Section } from "Shared/PageLayout";
import { translate } from "Shared/translate";
import DropDown from "Shared/DropDown";
import Overlay from "Shared/Overlay";
import { TINY } from "Shared/breakpoints";
import Icon from "Shared/Icon";
import { toggleDeliveryDays, showDeliveryDays, hideDeliveryDays, } from "SiteLayout/Header/action-creators";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import Button from "Shared/Button";
import { deliveryPageUrl } from "Shared/known-urls";
import Tooltip from "Shared/Tooltip";
import { updateAppShellData } from "./../../AppShell/action-creators";
import shallowEquals from "Shared/shallow-equals";
import MyMenigoIcon from "./../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import { SetSelectedDelivery } from "./action-creators";
import MenigoCalendar from "./Calendar";
import { replaceState } from "Shared/history";
import { deliveryDateChange } from "../../TrackingInformation";
const DATE_FORMAT = "YYYY-MM-DD";
class DeliveryDates extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = (e) => {
            e && e.preventDefault();
            this.setState({ showTooltip: !this.state.showTooltip });
        };
        moment.locale(this.props.culture);
        const deliveryDays = props.deliveryDays;
        const selectedDelivery = props.selectedDelivery;
        const deliveryDay = deliveryDays &&
            deliveryDays.find((d) => moment(selectedDelivery.departureDate).format(DATE_FORMAT) === d.date);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.state = {
            focused: true,
            activated: false,
            deliveryDays: deliveryDays,
            showTooltip: false,
            stopTime: selectedDelivery.stopTime,
            stopDate: moment(selectedDelivery.stopDate),
            selectedDelivery: selectedDelivery,
            shippingTimeHeader: this.getShippingTimeHeader(selectedDelivery),
            deliveryTimes: this.getDropDownOptions(deliveryDays, deliveryDay),
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return (nextProps.selectedDelivery !== this.props.selectedDelivery ||
            !shallowEquals(this.state, nextState, true));
    }
    componentDidMount() {
        // Due to issue with height, we need to rerender the calendar
        // https://github.com/airbnb/react-dates/issues/46
        setTimeout(() => {
            this.setState({
                activated: true,
            });
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.selectedDelivery !== this.props.selectedDelivery) {
            this.setSelectedDepartureDate(nextProps.selectedDelivery);
        }
    }
    isOutsideRange(day) {
        if (!!this.state.deliveryDays) {
            return !this.state.deliveryDays.find((d) => {
                return day.format(DATE_FORMAT) === d.date;
            });
        }
        return true;
    }
    isDaySelectable(day) {
        if (!!this.state.deliveryDays) {
            this.state.deliveryDays.find((d) => {
                if (d.deliveries.length > 0) {
                    return day.format(DATE_FORMAT) === d.date;
                }
            });
        }
        return false;
    }
    isCheckoutPage() {
        let pageType = this.props.componentName.split(".").pop();
        return pageType == "CheckoutPage";
    }
    getDropDownOptions(deliveryDays, deliveryDay) {
        let virtualDropdownItems = [];
        if (deliveryDays && deliveryDays.length > 0 && !!deliveryDay) {
            virtualDropdownItems = deliveryDay.deliveries.map((delivery, index) => {
                return { text: delivery.value, value: delivery.id };
            });
        }
        return virtualDropdownItems;
    }
    getShippingTimeHeader(delivery) {
        return delivery.departureDateAsString + ", " + delivery.value;
    }
    onDateChange(date) {
        const deliveryDateTemp = this.state.deliveryDays;
        this.setState({ deliveryDays: [] });
        const deliveryDay = deliveryDateTemp &&
            deliveryDateTemp.find((d) => moment(date.format(DATE_FORMAT)).isSame(moment(d.date)));
        const selectedDelivery = deliveryDay === null || deliveryDay === void 0 ? void 0 : deliveryDay.deliveries[0];
        this.selectDeliveryTimes(deliveryDay, selectedDelivery);
        if (!!deliveryDay && !!selectedDelivery) {
            SetSelectedDelivery(deliveryDay.date, selectedDelivery.departure, selectedDelivery.route).then((data) => {
                this.setState({
                    stopTime: data.stopTime,
                    stopDate: moment(data.stopDate),
                    deliveryDays: deliveryDateTemp,
                    shippingTimeHeader: this.getShippingTimeHeader(data),
                }, () => {
                    this.selectDeliveryTimes(deliveryDay, data);
                    this.persistDeparture();
                });
                this.ga4EventTrigger(deliveryDay.date);
            });
        }
    }
    ga4EventTrigger(deliveryDate) {
        var _a;
        let currentUser = (_a = window === null || window === void 0 ? void 0 : window.APP_SHELL_DATA) === null || _a === void 0 ? void 0 : _a.currentUser;
        deliveryDateChange(deliveryDate, currentUser === null || currentUser === void 0 ? void 0 : currentUser.customerId, currentUser === null || currentUser === void 0 ? void 0 : currentUser.customerType);
    }
    onFocusChange() {
        // Force the focused states to always be truthy so that date is always selectable
        this.setState({ focused: true });
    }
    selectDeparture(val) {
        const deliveryDay = this.state.deliveryDays &&
            this.state.deliveryDays.find((item) => item.deliveries.some((d) => d.id === val));
        const day = deliveryDay.deliveries.find((x) => x.id == val);
        !!day &&
            SetSelectedDelivery(day.departureDate, day.departure, day.route).then((data) => {
                this.setState({
                    stopTime: data.stopTime,
                    stopDate: moment(data.stopDate),
                    shippingTimeHeader: this.getShippingTimeHeader(data),
                }, () => {
                    this.selectDeliveryTimes(deliveryDay, data);
                    this.persistDeparture();
                });
            });
    }
    persistDeparture() {
        replaceState(location.href);
        // Reload app shell is currently needed because based on current date, prices and products will vary"
        this.props.reloadAppShell();
    }
    setSelectedDepartureDate(date) {
        const deliveryDay = this.state.deliveryDays.find((d) => moment(date.departureDate).format(DATE_FORMAT) === d.date);
        this.setState({
            stopTime: date.stopTime,
            stopDate: moment(date.stopDate),
            shippingTimeHeader: this.getShippingTimeHeader(date),
        }, () => this.selectDeliveryTimes(deliveryDay, date));
    }
    selectDeliveryTimes(deliveryDay, day) {
        this.setState({
            selectedDelivery: day,
            deliveryTimes: this.getDropDownOptions(this.state.deliveryDays, deliveryDay),
        });
    }
    render() {
        const isTooltip = this.props.currentBreakpoint > TINY;
        const myOrdersUrl = deliveryPageUrl();
        const calendar = (React.createElement("div", { className: this.props.className, "data-opti-id": "component-date-picker" },
            !!!this.props.hideHeader && (React.createElement("div", { className: classnames(styles.deliveryHeader, this.props.hasWrapper && styles.positionRelative) },
                React.createElement("h5", null, translate("/DeliveryDate/ChooseDateHeader")))),
            React.createElement(Section, { className: classnames(styles.shippingDateInfo, this.props.hasWrapper && styles.shippingDateInfo_Layout2) },
                React.createElement("div", null,
                    !this.props.hasWrapper && (React.createElement("div", { className: styles.closeDatePicker },
                        React.createElement("a", { onClick: () => this.props.hideDeliveryDays() },
                            React.createElement(Icon, { name: "close" })))),
                    React.createElement("div", { className: classnames(styles.headerWrapper, this.props.hasWrapper && styles.headerLayout2) }, !!this.state.deliveryDays ? (React.createElement("div", { className: styles.header },
                        React.createElement("b", null,
                            translate("/DeliveryDate/SelectedDeliveryHeader"),
                            ": "),
                        React.createElement("b", null, this.state.shippingTimeHeader),
                        !!this.state.stopDate && (React.createElement("p", null,
                            translate("/DeliveryDate/StopTime"),
                            ":",
                            " ",
                            this.state.stopDate.format(DATE_FORMAT),
                            ",",
                            " ",
                            this.state.stopTime)))) : (React.createElement("div", { className: classnames(styles.header, styles.error) },
                        React.createElement("b", null, translate("/DeliveryDate/NoDeliveryDatesFound")))))),
                React.createElement("div", { className: classnames(styles.helpButtonWrapper, this.props.hasWrapper && styles.pushup) },
                    React.createElement(Button, { className: styles.helpButton, appearance: "secondary", onClick: this.toggleTooltip, "aria-label": translate("/DeliveryDate/HelpButton/AreaLabel") },
                        React.createElement(Icon, { name: "question" })),
                    this.state.showTooltip && (React.createElement("div", { className: styles.tooltipWrapper },
                        React.createElement(Tooltip, { close: this.toggleTooltip, closeButton: true, closeOnClick: false, horizontal: "right" },
                            React.createElement("div", { className: styles.tooltip },
                                React.createElement("h4", null,
                                    translate("/DeliveryDate/ToolboxHeader"),
                                    ": "),
                                React.createElement("div", { className: styles.helpSectionButtonWrapper },
                                    React.createElement(Button, { className: styles.helpSelected, appearance: "round" },
                                        React.createElement("span", null, "10")),
                                    " ",
                                    translate("/DeliveryDate/HelpSelected")),
                                React.createElement("b", null,
                                    translate("/DeliveryDate/HelptextAboutStop"),
                                    ": "),
                                React.createElement("p", null, translate("/DeliveryDate/HelpTextStopTime")),
                                React.createElement("b", null,
                                    translate("/DeliveryDate/HelptextAboutCalendar"),
                                    ": "),
                                React.createElement("p", null, translate("/DeliveryDate/HelpTextCalendar")),
                                React.createElement("b", null,
                                    translate("/DeliveryDate/HelptextAboutDeparture"),
                                    ": "),
                                React.createElement("p", null, translate("/DeliveryDate/HelpTextDeparture"))))))),
                this.state.activated && (React.createElement("div", { className: classnames(styles.datePicker, this.props.hasWrapper ? null : styles.ownWrapper) },
                    React.createElement(MenigoCalendar, { value: this.state.selectedDelivery
                            ? new DateObject(this.state.selectedDelivery.departureDate)
                            : null, mapDays: ({ date }) => {
                            const isNotAllowed = this.isOutsideRange(moment(date.toString()));
                            return {
                                disabled: isNotAllowed,
                                style: isNotAllowed
                                    ? { color: "#cacccd", borderRadius: '0px', border: 'none' }
                                    : date.toString() == this.state.selectedDelivery.departureDateAsString ? { backgroundColor: '#000', borderRadius: '0px' } : {},
                            };
                        }, onFocusedDateChange: (date, clickedDate) => { this.onDateChange(moment(clickedDate.toString())); } }))),
                this.state.deliveryTimes.length > 1 && (React.createElement("div", { className: styles.dropdownWrapper },
                    React.createElement(DropDown, { options: this.state.deliveryTimes, value: this.state.selectedDelivery.id, onChange: (selection) => this.selectDeparture(selection) }))),
                React.createElement("a", { href: myOrdersUrl.url, className: styles.myOrdersLink, onClick: () => this.props.hideDeliveryDays() },
                    translate("/DeliveryDate/LinktoMyOrdersText"),
                    " ",
                    React.createElement(MyMenigoIcon, { name: "arrow" })))));
        return !!this.props.hasWrapper ? (calendar) : (React.createElement(Overlay, { enabled: isTooltip && this.props.deliveryDaysIsVisible, onClose: () => !this.state.showTooltip && this.props.hideDeliveryDays() }, calendar));
    }
}
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
    deliveryDaysIsVisible: state.deliveryDaysVisibility.visible,
    culture: state.appShellData.culture,
    componentName: state.currentPage.componentName,
}), (dispatch) => ({
    toggleDeliveryDays() {
        dispatch(toggleDeliveryDays());
    },
    hideDeliveryDays() {
        dispatch(hideDeliveryDays());
    },
    showDeliveryDays() {
        dispatch(showDeliveryDays());
    },
    reloadAppShell() {
        return dispatch(updateAppShellData());
    },
}))(DeliveryDates);
